export const getLocalState = state => state.selection

export const getSelection = state => getLocalState(state).selection
export const getHidden = state => getLocalState(state).hidden
export const getIsIsolationActive = state => getLocalState(state).isIsolationActive
